import script from "./Opportunity.vue?vue&type=script&setup=true&lang=js"
export * from "./Opportunity.vue?vue&type=script&setup=true&lang=js"

import "./Opportunity.vue?vue&type=style&index=0&id=0a526375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a526375"]])

export default __exports__